import React from 'react';
import { Link, withRouter } from "react-router-dom";
import { CSSTransition } from 'react-transition-group';
import { MediaQueryContext } from '../MediaQueryContext';
import { routes } from '../nav/Nav';
import PageContainer from '../PageContainer';
import './exhibitions.scss';
import { faArrowRight, faTimes } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import PageTitle from '../PageTitle';
import background from '../images/stina-new.gif';
import { greyText } from '../styles';

class Exhibitions extends React.Component {
  static contextType = MediaQueryContext;

  constructor(props) {
    super(props);
    this.state = { currentDot: null, dotStyle: {}, currentScroll: window.scrollY, validRoutes: routes.filter(route => !route.excludes || !route.excludes.includes(props.location.pathname)) }
    this.pause = false;
    this.removeDot = this.removeDot.bind(this)
    this.handleMouseMove = this.handleMouseMove.bind(this);
    this.onScroll = this.onScroll.bind(this)
  }

  componentDidMount() {
    window.addEventListener('scroll', this.onScroll);
  }
  componentWillUnmount() {
    window.removeEventListener('scroll', this.onScroll);

  }

  onScroll() {
    this.setState({ currentScroll: window.scrollY });
  }

  setDot(currentDot) {
    if (this.state.currentDot !== null) {
      return this.setState({ currentDot: null });
    }
    let timeout = this.context.isMobile ? 1 : 100;
    if (this.state.currentDot !== currentDot && !this.pause) {
      this.pause = true;
      setTimeout(() => { this.pause = false }, timeout);
      this.timeout = setTimeout(() => { this.setState({ currentDot }); }, timeout);
    }

  }

  renderActiveDot(index, route) {
    let isActive = this.state.currentDot === route;

    let style = document.querySelector("#dot-" + index)?.getBoundingClientRect();
    let dotStyle = isActive ? {
      top: 0,
      left: 0,
      height: this.context.isDesktop ? '200vw' : '200vh',
      width: this.context.isDesktop ? '200vw' : '200vh',
      borderRadius: '50%',
      backgroundImage: `${route.backgroundImage}`
    } : {
      opacity: 0,
      top: style?.top,
      left: style?.left,
      right: style?.right,
      bottom: style?.bottom,
      height: style?.height,
      width: style?.width,
      borderRadius: '50%',
      backgroundImage: `${route.backgroundImage}`
    };

    let className = "active-dot " + "exhibition-" + route.path?.toLowerCase().replaceAll("/", "")

    if (isActive) {
      className += " open";
    }

    let length = route.label.length;
    console.log(length)
    let fontSize = 820 / length;
    fontSize = Math.min(fontSize, this.context.isMobile ? 42 : 96);
    fontSize = Math.max(fontSize, this.context.isMobile ? 24 : 46);

    let pFontSize = 820 / (route.description.length + route.descriptionNorwegian.length);
    pFontSize = Math.min(pFontSize, 32);
    pFontSize = Math.max(pFontSize, this.context.isMobile ? 16 : 26);

    return (
      <div className={className} style={dotStyle} onClick={this.removeDot.bind(this)}  >
        {isActive && <FontAwesomeIcon className="close-icon" icon={faTimes} onClick={this.state.currentDot !== null && this.removeDot.bind(this)} />}

        <CSSTransition timeout={900} in={isActive} classNames="text-in" unmountOnExit mountOnEnter >

          <div className="text-in">
            <h2 style={{ fontSize: fontSize + 'px' }}>{route.label}</h2>
            <p style={{ fontSize: pFontSize + 'px' }}>
              <span>{route.description}</span>
              <br />
              <span style={{ color: greyText }}>{route.descriptionNorwegian}</span>
            </p>

            <Link to={route.path} className="button secondary"> <span>Go to station</span> <FontAwesomeIcon icon={faArrowRight}></FontAwesomeIcon></Link>
          </div>

        </CSSTransition>


      </div>


    );

  }

  removeDot() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
    if (!this.pause) {
      this.setState({ currentDot: null });

    }
  }

  handleMouseMove(e) {
    this.setState({ x: e.pageX, y: e.pageY });
  }

  render() {
    let leftRatio = (this.state.x / window.innerWidth);
    //let rightRatio = 100 - leftRatio;
    let topRatio = (this.state.y / window.innerHeight);
    let backgroundX1 = ((0.5 - leftRatio) * 30);
    let backgroundX2 = ((0.5 - leftRatio) * -30);
    let backgroundY1 = ((0.5 - topRatio) * 30);
    let backgroundY2 = ((0.5 - topRatio) * -30);
    let style1 = { transform: `translate(${backgroundX1}vw, ${backgroundY1}vh)` };
    let style2 = { transform: `translate(${backgroundX2}vw, ${backgroundY2}vh)` };

    return (
      <PageContainer {...this.props} className="exhibitions">
        <div className="backgrounds" onMouseMove={this.handleMouseMove}>
          <img src={background} className="background" id="background-1" alt="a woman dancing" />
          <img src={background} className="background" id="background-2" alt="a woman dancing" style={style1} />
          <img src={background} className="background" id="background-3" alt="a woman dancing" style={style2} />
        </div>

        <div className="content" >

          {this.state.validRoutes.map((route, index) => (
            <div className="circle-link" onClick={(e) => this.setDot(route)}
            >
              {/* onMouseEnter={(e) => this.context.isDesktop && this.setDot(route)}*/}
              <div className="circle" id={"dot-" + index} style={{ backgroundImage: `${route.navBackgroundImage || route.backgroundImage}`, opacity: this.state.currentDot !== null ? 0 : 1 }}>
                {index > 0 && <div className="flex-row dots"> {[...Array(index).keys()].map(dot => <div className="dot" />)}</div>}
              </div>

              { this.renderActiveDot(index, route)}

            </div>
          )
          )

          }

        </div>


        <PageTitle >STATIONS</PageTitle>

      </PageContainer >
    );
  }
}

export default withRouter(Exhibitions);
